import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isAdminSelector } from '../../../store/auth/selectors';
import { constants } from '../../../common/constants/constants';
import { renderIcon, renderOneTimeIcon, parseValues } from '../../../common/utils/yearlyRowsLogic';

const YearlyPdfRow = ({ record, oneTimeHeaders }) => {
    const isAdmin = useSelector(isAdminSelector);

    const { apartmentNumber, total } = record;

    const [oneTimeSum, setOneTimeSum] = useState();

    let oneTimeSumObj = {
        amount_left: {value: 0, currency: ''},
        paid: {value: 0, currency: ''},
        scheduled_to_pay: {value: 0, currency: ''},
        total: {value: 0, currency: ''}
    };

    const sumOneTime = arr => {
        if (arr.length === 0) return null
        else if (arr.length === 1) setOneTimeSum(arr[0][1])
        else if(arr.length > 1) {
            arr.map(el => {
                const current = el[1];
                oneTimeSumObj.amount_left.value += +current.amount_left.value;
                oneTimeSumObj.total.value += +current.total.value;
                oneTimeSumObj.paid.value += +current.paid.value;
                oneTimeSumObj.scheduled_to_pay.value += +current.scheduled_to_pay.value;
                oneTimeSumObj.amount_left.currency = current.amount_left.currency;
                oneTimeSumObj.total.currency = current.total.currency;
                oneTimeSumObj.paid.currency = current.paid.currency;
                oneTimeSumObj.scheduled_to_pay.currency = current.scheduled_to_pay.currency;
                return oneTimeSumObj
            })
            setOneTimeSum(oneTimeSumObj);
        }
    };

    useEffect(() => {
        const oneTimeArrays = Object.entries(record).filter(([key]) => key.includes('one_time'));
        sumOneTime(oneTimeArrays);
    }, [record]);

    const monthNames = Object.values(constants.MonthsToText);

    return (
        <div className='pdf-row'>
            <div className='yearly-apt pdf-highlited'>{apartmentNumber}</div>
            {monthNames.map((month, i) => <div className='yearly'>{renderIcon(record[month], {}, isAdmin, i, true).paid}</div>)}
            <div className='yearly'>{oneTimeHeaders.length > 0 && renderOneTimeIcon(oneTimeSum)}</div>
            <div className='yearly'>{parseValues(total?.charged.value)}</div>
            <div className='yearly'>{parseValues(total?.debt.value)}</div>
            <div className='yearly'>{parseValues(total?.future.value)}</div>
        </div>
    )
}

export default YearlyPdfRow;